"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWhereKey = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const entity_ui_1 = require("@sierralabs/entity-ui");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const ColumnsSelector_1 = __importDefault(require("./ColumnsSelector"));
const OperatorSelector_1 = __importDefault(require("./OperatorSelector"));
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const WhereDateFilter_1 = __importStar(require("../common/WhereDateFilter"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  .where-type-selector {
    /* margin-right: 6px; */
  }
  .where-operator-selector {
    /* margin: 0 6px; */
  }
  .entity-field .MuiInputBase-root {
    padding: 4px;
  }
  .entity-field .MuiInputBase-input {
    padding: 5px;
  }
  .entity-field .MuiSelect-root {
    padding-right: 32px;
  }
  .MuiAutocomplete-hasPopupIcon .entity-field .MuiInputBase-root {
    padding-right: 39px;
  }
  .expression-field {
    min-width: 96px;
  }
  .expression-field:not(:last-child) {
    /* margin-right: 6px; */
  }
  .operator-any-controls {
    padding-top: 4px;
    .MuiIconButton-root:not(:last-child) {
      margin-right: 2px;
    }
  }
`;
const whereTypes = [
    // { value: 'simple', label: 'simple' },
    { value: 'and', label: 'AND' },
    { value: 'or', label: 'OR' }
];
const wrappingOperator = 'not';
function generateWhereKey(wheres, index) {
    const where = wheres[index];
    const condition = where.condition;
    const columnName = condition === null || condition === void 0 ? void 0 : condition.parameters[0];
    let key = `${index}:${where.type}:${condition === null || condition === void 0 ? void 0 : condition.operator}:`;
    if (columnName) {
        key += columnName;
        const nextMatch = wheres.findIndex((w, i) => {
            var _a;
            return i > index &&
                ((_a = w.condition) === null || _a === void 0 ? void 0 : _a.parameters[0]) === columnName;
        });
        if (nextMatch > -1) {
            // append index if found same column name used in multiple where
            // conditions
            key += `:${nextMatch}`;
        }
    }
    return key;
}
exports.generateWhereKey = generateWhereKey;
const WhereSelector = (_a) => {
    var { vertical, queryAliasColumnMap: queryAliasColumnMapProp, onChange, onDelete } = _a, props = __rest(_a, ["vertical", "queryAliasColumnMap", "onChange", "onDelete"]);
    const onChangeRef = (0, react_1.useRef)(onChange);
    onChangeRef.current = onChange;
    const { plugins } = (0, entity_ui_1.useEntityContext)();
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const queryAliasColumnMap = queryAliasColumnMapProp || queryManager.queryAliasColumnMap;
    const [where, setWhere] = (0, react_1.useState)({
        type: props.where.type || 'simple',
        condition: props.where.condition
    });
    const wherePredicateOperator = where.condition;
    const columnValue = (wherePredicateOperator === null || wherePredicateOperator === void 0 ? void 0 : wherePredicateOperator.parameters)
        ? wherePredicateOperator.parameters[0]
        : where.condition;
    const columnAliasPath = (wherePredicateOperator === null || wherePredicateOperator === void 0 ? void 0 : wherePredicateOperator.parameters)
        ? wherePredicateOperator.parameters[0]
        : undefined;
    const [alias, property] = columnAliasPath ? columnAliasPath.split('.') : [];
    const columnMap = queryAliasColumnMap.find(map => {
        var _a;
        return (map.alias === alias && ((_a = map.column) === null || _a === void 0 ? void 0 : _a.name) === property) || // match entity column properties
            map.path === columnAliasPath;
    } // match plugin columns
    );
    const plugin = plugins.find(p => {
        var _a;
        let type = (_a = columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) === null || _a === void 0 ? void 0 : _a.type;
        if (['tsvector', 'citext'].includes(type))
            type = 'text';
        if (type === 'int' || type === 'smallint')
            type = 'integer';
        return p.type === type;
    });
    // get metadata for selected column
    const [selectedColumnMeta, setSelectedColumnMeta] = (0, react_1.useState)();
    // keep column metadata up to date
    (0, react_1.useEffect)(() => {
        if (columnValue && (columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) && (columnMap === null || columnMap === void 0 ? void 0 : columnMap.entity)) {
            setSelectedColumnMeta({
                value: columnValue,
                column: columnMap.column,
                entity: columnMap.entity
            });
        }
    }, [columnMap === null || columnMap === void 0 ? void 0 : columnMap.column, columnMap === null || columnMap === void 0 ? void 0 : columnMap.entity, columnValue]);
    // validate where and notify change event
    const [conditionError, setConditionError] = (0, react_1.useState)('');
    const [expressionError, setExpressionError] = (0, react_1.useState)('');
    const handleWhereChange = (0, react_1.useCallback)((where, columnMeta = selectedColumnMeta) => {
        var _a, _b;
        setWhere(where);
        if (!where.condition)
            setConditionError('Field required.');
        if (columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.column) {
            // structured where condition (WherePredicateOperator)
            const condition = where.condition;
            if (!condition.operator) {
                setConditionError('Invalid field value.');
            }
            else if (!validateParameters(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.column, condition)) {
                setExpressionError('Value required.');
            }
            else {
                setConditionError('');
                setExpressionError('');
                (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, where);
            }
        }
        else {
            // freesolo where condition
            (_b = onChangeRef.current) === null || _b === void 0 ? void 0 : _b.call(onChangeRef, where);
        }
    }, [selectedColumnMeta]);
    return Array.isArray(where.condition) ? (
    // Handle nested where clause (the query builder currently doesn't do this,
    // but it is supported via API)
    react_1.default.createElement(react_1.default.Fragment, null, where.condition.map((nestedWhere, index) => (react_1.default.createElement(WhereSelector, { key: generateWhereKey(where.condition, index), where: nestedWhere, onChange: nestedWhere => {
            where.condition[index] = nestedWhere;
            handleWhereChange(where);
        }, onDelete: () => {
            where.condition.splice(index, 1);
            handleWhereChange(where);
        } }))))) : (
    // regular where clause handling
    (() => {
        var _a, _b, _c;
        const condition = where.condition;
        return (react_1.default.createElement(StyledDiv, { className: 'where-selector-container' },
            where.type !== 'simple' && (react_1.default.createElement(QueryFieldSelector_1.default, { className: 'where-type-selector', placeholder: 'AND/OR', value: whereTypes.find(o => o.value === props.where.type), options: whereTypes, getOptionLabel: option => (option === null || option === void 0 ? void 0 : option.label) || '', onChange: option => {
                    handleWhereChange(Object.assign(Object.assign({}, where), { type: option.value }));
                } })),
            react_1.default.createElement(ColumnsSelector_1.default, { vertical: true, freesolo: true, value: columnValue, error: Boolean(conditionError), helperText: conditionError, queryAliasColumnMap: queryAliasColumnMap, onColumnChange: (value, index, columnMap) => {
                    const { column, entity } = columnMap || {};
                    if (column) {
                        const columnMeta = { value, column, entity };
                        setSelectedColumnMeta(columnMeta);
                        const parameters = [value];
                        // default boolean to false
                        if (column.type === 'boolean')
                            parameters.push(false);
                        handleWhereChange(Object.assign(Object.assign({}, where), { 
                            // default operator to 'equal'
                            condition: { operator: 'equal', parameters } }), columnMeta);
                    }
                    else {
                        // freesolo condition
                        setSelectedColumnMeta(undefined);
                        handleWhereChange(Object.assign(Object.assign({}, where), { condition: value }), {});
                    }
                }, onDelete: onDelete }),
            (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.column) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(OperatorSelector_1.default, { column: selectedColumnMeta.column, value: condition === null || condition === void 0 ? void 0 : condition.operator, onChange: value => {
                        condition.operator = value;
                        if (value === 'isNull') {
                            // remove any other params
                            where.condition.parameters.length = 1;
                        }
                        handleWhereChange(Object.assign({}, where));
                    } }),
                (condition === null || condition === void 0 ? void 0 : condition.operator) === 'any' &&
                    condition.parameters.slice(1).map((parameter, index) => {
                        var _a;
                        // condition not working if outside map function
                        if (!((_a = plugin === null || plugin === void 0 ? void 0 : plugin.edit) === null || _a === void 0 ? void 0 : _a.field) ||
                            !(selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.column) ||
                            !(selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.entity)) {
                            return null;
                        }
                        return (react_1.default.createElement("div", { key: index, className: 'expression-field' },
                            react_1.default.createElement(plugin.edit.field, { plugin: plugin, column: selectedColumnMeta.column, entity: selectedColumnMeta.entity, value: parameter || '', error: Boolean(expressionError), helperText: expressionError, onChange: value => {
                                    where.condition.parameters[index + 1] = value;
                                    handleWhereChange(Object.assign({}, where));
                                } })));
                    }),
                ((_a = plugin === null || plugin === void 0 ? void 0 : plugin.edit) === null || _a === void 0 ? void 0 : _a.field) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.column) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.entity) &&
                    (condition === null || condition === void 0 ? void 0 : condition.operator) === 'any' && (react_1.default.createElement("div", { className: 'operator-any-controls' },
                    react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => {
                            const { parameters } = where.condition;
                            parameters.push('');
                            handleWhereChange(Object.assign({}, where));
                        } },
                        react_1.default.createElement(core_1.Icon, null, "add")),
                    react_1.default.createElement(core_1.IconButton, { size: 'small', disabled: condition.parameters.length < 3, onClick: () => {
                            const { parameters } = where.condition;
                            if (parameters.length > 2) {
                                parameters.splice(parameters.length - 1, 1);
                                handleWhereChange(Object.assign({}, where));
                            }
                        } },
                        react_1.default.createElement(core_1.Icon, null, "remove")))),
                ((_b = plugin === null || plugin === void 0 ? void 0 : plugin.edit) === null || _b === void 0 ? void 0 : _b.field) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.column) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.entity) &&
                    !['any', 'isNull'].includes((condition === null || condition === void 0 ? void 0 : condition.operator) || '') && (react_1.default.createElement(react_1.default.Fragment, null, ['timestamp', 'date'].includes(plugin.type) ? (react_1.default.createElement(WhereDateFilter_1.default, { plugin: plugin, column: selectedColumnMeta.column, entity: selectedColumnMeta.entity, filterType: (0, WhereDateFilter_1.isDateRangeFilterType)(condition.parameters[1])
                        ? condition.parameters[1]
                        : 'date', value: (0, WhereDateFilter_1.isDateRangeFilterType)(condition.parameters[1])
                        ? condition.parameters[2]
                        : condition.parameters[1], unit: (0, WhereDateFilter_1.isDateRangeFilterType)(condition.parameters[1])
                        ? condition
                            .parameters[3] || 'day'
                        : undefined, error: Boolean(expressionError), helperText: expressionError, onChange: (filterType, value, unit) => {
                        const condition = where.condition;
                        let params = condition.parameters;
                        if ((0, WhereDateFilter_1.isDateRangeFilterType)(filterType)) {
                            params = [
                                params[0],
                                filterType,
                                value || '',
                                unit || ''
                            ];
                        }
                        else {
                            params = [params[0], value || ''];
                        }
                        condition.parameters = params;
                        handleWhereChange(Object.assign({}, where));
                    } })) : (react_1.default.createElement("div", { className: 'expression-field' },
                    react_1.default.createElement(plugin.edit.field, { plugin: plugin, column: selectedColumnMeta.column, entity: selectedColumnMeta.entity, value: condition === null || condition === void 0 ? void 0 : condition.parameters[1], error: Boolean(expressionError), helperText: expressionError, onChange: value => {
                            where.condition.parameters[1] = value;
                            handleWhereChange(Object.assign({}, where));
                        } }))))),
                ((_c = plugin === null || plugin === void 0 ? void 0 : plugin.edit) === null || _c === void 0 ? void 0 : _c.field) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.column) &&
                    (selectedColumnMeta === null || selectedColumnMeta === void 0 ? void 0 : selectedColumnMeta.entity) &&
                    (condition === null || condition === void 0 ? void 0 : condition.operator) === 'between' && (react_1.default.createElement("div", { className: 'expression-field' },
                    react_1.default.createElement(plugin.edit.field, { plugin: plugin, column: selectedColumnMeta.column, entity: selectedColumnMeta.entity, value: (condition === null || condition === void 0 ? void 0 : condition.parameters[2]) || '', error: Boolean(expressionError), helperText: expressionError, onChange: value => {
                            where.condition.parameters[2] = value;
                            handleWhereChange(Object.assign({}, where));
                        } })))))));
    })());
};
exports.default = WhereSelector;
/**
 * Check WherePredicateOperator parameters
 * @param parameters
 */
const validateParameters = (column, wherePredicateOperator) => {
    switch (wherePredicateOperator.operator) {
        case 'isNull':
            return wherePredicateOperator.parameters.length === 1;
        case 'between':
            return wherePredicateOperator.parameters.length === 3;
        case 'any':
        case 'in':
            return wherePredicateOperator.parameters.length >= 2;
        default:
            if (['date', 'timestamp'].includes(column.type)) {
                return (0, WhereDateFilter_1.isDateRangeFilterType)(wherePredicateOperator.parameters[1])
                    ? 4
                    : 2;
            }
            else {
                return wherePredicateOperator.parameters.length === 2;
            }
    }
};
//# sourceMappingURL=WhereSelector.js.map